import type { IEntity, IPoint } from "dxf-parser";
import type { IGroup } from "dxf-parser/dist/DxfArrayScanner";
import type DxfArrayScanner from "dxf-parser/dist/DxfArrayScanner";
import type IGeometry from "dxf-parser/dist/entities/geomtry";
import * as helpers from "lib/house/dxf/import/dxfParserLibHelpers";
import {
  createDStyleScanState,
  dstyleScanResult,
  feedDStyleGroup,
  type DXFDimStyleOverrides,
} from "lib/house/dxf/import/parseDXFDimStyle";

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface ILeaderEntity extends IEntity {
  vertices: IPoint[];
  arrowHead?: boolean;
  annotationHandle?: string;
  extrusionDirection?: IPoint;
  styleName?: string;
  dstyleOverrides?: DXFDimStyleOverrides;
}

export default class Leader implements IGeometry {
  public ForEntityName = "LEADER" as any; // this is hacky because the library doesn't expect this
  public parseEntity(scanner: DxfArrayScanner, curr: IGroup) {
    const entity = {
      type: curr.value,
      vertices: [] as IPoint[],
    } as ILeaderEntity;
    const dstyleScan = createDStyleScanState();

    curr = scanner.next();
    while (!scanner.isEOF()) {
      if (curr.code === 0) {
        break;
      }

      switch (curr.code) {
        case 3:
          entity.styleName = curr.value as string;
          break;
        case 10: // X coordinate of the first vertex
        case 20: // Y coordinate
        case 30: // Z coordinate
          // Parse a point (combine X, Y, Z based on sequential group codes)
          entity.vertices.push(helpers.parsePoint(scanner));
          break;
        case 71: // Arrowhead flag (1 = has arrowhead, 0 = no arrowhead)
          entity.arrowHead = curr.value === 1;
          break;
        case 341: // Annotation handle
          entity.annotationHandle = curr.value as string;
          break;
        case 210: // Extrusion direction (X)
        case 220: // Extrusion direction (Y)
        case 230: // Extrusion direction (Z)
          entity.extrusionDirection = helpers.parsePoint(scanner);
          break;
        default:
          if (feedDStyleGroup(dstyleScan, curr.code, curr.value as string | number)) {
            break; // DSTYLE xdata group consumed
          }
          helpers.checkCommonEntityProperties(entity, curr, scanner);
          break;
      }

      curr = scanner.next();
    }
    entity.dstyleOverrides = dstyleScanResult(dstyleScan);
    return entity;
  }
}
